import React from "react";
import { Play, Loader2, Power } from "lucide-react";

const AutopilotSwitch = ({ s, sentToday, running, isMaster, onRun, onToggle }) => {
  const on = s.enabled;
  return (
    <div className={`rounded-xl p-5 mb-5 flex items-center justify-between ${on ? "bg-emerald-50 border border-emerald-200" : "bg-neutral-100 border border-neutral-200"}`} data-testid="autopilot-switch">
      <div className="flex items-center gap-3">
        <div className={`rounded-lg p-2.5 ${on ? "bg-emerald-500 text-white" : "bg-neutral-300 text-neutral-600"}`}><Power size={20} /></div>
        <div>
          <p className="font-semibold text-neutral-900">{on ? "Pilote activé" : "Pilote désactivé"}</p>
          <p className="text-sm text-neutral-500">{sentToday}/{s.daily_cap} emails envoyés aujourd'hui</p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <button onClick={onRun} disabled={running} data-testid="autopilot-run-btn" className="flex items-center gap-2 border border-neutral-300 text-neutral-700 hover:border-brand text-sm font-semibold px-4 py-2 rounded-md disabled:opacity-60">
          {running ? <Loader2 size={15} className="animate-spin" /> : <Play size={15} />} Lancer une action maintenant
        </button>
        {isMaster && (
          <button onClick={onToggle} data-testid="autopilot-toggle-btn" className={`text-sm font-semibold px-5 py-2 rounded-md text-white ${on ? "bg-neutral-800 hover:bg-neutral-900" : "bg-brand hover:bg-brand-dark"}`}>
            {on ? "Désactiver" : "Activer"}
          </button>
        )}
      </div>
    </div>
  );
};

export default AutopilotSwitch;
